import { useFiles } from "@ip-modules/tax";

import Select from "../index";

export default function File(props) {
  const { files } = useFiles();

  const items = [...new Set(files?.map((item) => item.entity))];

  return <Select label="Entity" items={items} {...props} />;
}
